import {ActionBase} from '../../helpers/reduxHelpers';
import {OptimisticUpdateId} from './optimisticUpdatesState';

/*
 * Constants.
 */

export const optimisticUpdatesFinishIdsKey = Symbol('$$optimisticUpdatesFinishIds');

/*
 * Types.
 */

/** Implemented by actions that finish optimistic updates, such as API completion actions. */
export interface OptimisticUpdatesFinishIdsActionExtension {
  [optimisticUpdatesFinishIdsKey]: ReadonlyArray<OptimisticUpdateId>;
}

/*
 * Type guards.
 */

export function hasOptimisticUpdatesFinishIdsActionExtension<A extends ActionBase>(
  action: A,
): action is A & OptimisticUpdatesFinishIdsActionExtension {
  return optimisticUpdatesFinishIdsKey in action;
}
